var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const initBundle = /* @__PURE__ */ __name(($el, $refs) => {
  var _a, _b, _c, _d, _e, _f;
  const random_id = utils.shortUUID();
  const bundle_products = (_a = [...$el.querySelectorAll("[data-product-handle][data-product-id]")]) == null ? void 0 : _a.map((element) => ({
    element,
    ..._product.getHtmlProduct(element.getAttribute("data-product-handle"))
  }));
  const sort_values = ["day", "week", "month", "year"];
  const selling_plan_options = [];
  const section_settings = utils.JSONParse($el.getAttribute("data-section-settings"));
  const select_settings = utils.JSONParse(
    (_b = $el.querySelector("[data-select-settings]")) == null ? void 0 : _b.getAttribute("data-select-settings")
  );
  const select_type = (_c = select_settings == null ? void 0 : select_settings.type) != null ? _c : "auto";
  const bundle_targets = (_d = Array.from($el.querySelectorAll("[data-bundle-target]"))) == null ? void 0 : _d.flatMap(
    (el) => {
      var _a2;
      return (_a2 = utils.JSONParse(
        el.getAttribute("data-bundle-target")
      )) != null ? _a2 : [];
    }
  );
  const initial_bundle_target_id = (_e = bundle_targets == null ? void 0 : bundle_targets[0]) == null ? void 0 : _e.id;
  const initial_target = {
    ...bundle_targets == null ? void 0 : bundle_targets[0]
  };
  bundle_targets == null ? void 0 : bundle_targets.sort((a, b) => {
    var _a2, _b2;
    return ((_a2 = a.settings) == null ? void 0 : _a2.target) - ((_b2 = b == null ? void 0 : b.settings) == null ? void 0 : _b2.target);
  });
  const bundle_target_objects = bundle_targets == null ? void 0 : bundle_targets.reduce((acc, item, i) => {
    acc[item.id] = item.settings;
    return acc;
  }, {});
  const incentive_targets = (_f = Array.from($el.querySelectorAll("[data-bundle-incentive-target]"))) == null ? void 0 : _f.flatMap(
    (el) => {
      var _a2;
      return (_a2 = utils.JSONParse(
        el.getAttribute("data-bundle-incentive-target")
      )) != null ? _a2 : [];
    }
  );
  const bundle_type = section_settings.bundle_target_type;
  const addToBundle = /* @__PURE__ */ __name(({
    product,
    variant,
    price
  }) => {
    var _a2, _b2, _c2;
    if ((variant == null ? void 0 : variant.inventory_management) && (variant == null ? void 0 : variant.inventory_policy) !== "continue") {
      const quantity_added = state.items_added.reduce((acc, item) => {
        var _a3;
        if (((_a3 = item == null ? void 0 : item.variant) == null ? void 0 : _a3.id) === variant.id) {
          acc += 1;
        }
        return acc;
      }, 0);
      if (variant.inventory_quantity - quantity_added < 1) {
        _stores.toast.addToast({
          type: "error",
          title: "Not enough inventory",
          content: "It looks like you already added the item and the inventory limit has been reached."
        });
        return;
      }
    }
    if (section_settings.restrict_bundle_quantity === "hard_limit") {
      if ((state == null ? void 0 : state[bundle_type]) < ((_a2 = state.bundle_target) == null ? void 0 : _a2.target)) {
        state.items_added.push({ product, variant, price_override: price });
      }
      return;
    }
    if (section_settings.restrict_bundle_quantity === "upgrade_limit") {
      const lastBundleTarget = (_b2 = [...bundle_targets].sort((a, b) => {
        var _a3, _b3;
        return ((_a3 = a == null ? void 0 : a.settings) == null ? void 0 : _a3.target) - ((_b3 = b == null ? void 0 : b.settings) == null ? void 0 : _b3.target);
      })) == null ? void 0 : _b2.at(-1);
      if ((state == null ? void 0 : state[bundle_type]) < ((_c2 = lastBundleTarget == null ? void 0 : lastBundleTarget.settings) == null ? void 0 : _c2.target)) {
        state.items_added.push({ product, variant, price_override: price });
      } else {
        _stores.toast.addToast({
          type: "warning",
          title: "Your Bundle is already complete!"
        });
        return;
      }
    }
    if (section_settings.restrict_bundle_quantity === "no_limit") {
      if ((state == null ? void 0 : state[bundle_type]) < state.max_bundle_quantity) {
        state.items_added.push({ product, variant, price_override: price });
      }
    }
    updateBundleById();
  }, "addToBundle");
  const removeFromBundle = /* @__PURE__ */ __name(({
    product,
    variant
  }) => {
    var _a2;
    const index = (_a2 = state.items_added) == null ? void 0 : _a2.findLastIndex((item) => {
      var _a3;
      return ((_a3 = item == null ? void 0 : item.variant) == null ? void 0 : _a3.id) === (variant == null ? void 0 : variant.id) && item.product.id === product.id;
    });
    state.items_added.splice(index, 1);
  }, "removeFromBundle");
  const state = window.Alpine.reactive({
    items_added: [],
    bundle_target_titles: [],
    item_added_summary: [],
    bundle_target_id: initial_bundle_target_id,
    total_price: 0,
    discounted_price: 0,
    current_wording: "",
    difference_wording: "",
    target_wording: "",
    final_price: 0,
    subscription_price_before_discounts: 0,
    subscription_price: 0,
    before_discounts_price: 0,
    selling_plan_discount_wording: "",
    selling_plan_discount_wording_old: "",
    target_discount_wording: "",
    active_target_discount_wording: "",
    discount_wording: "",
    active_discount_wording: "",
    item_count: 0,
    target_difference: "",
    selling_plan_options,
    selected_selling_plan: null,
    bundle_target: initial_target == null ? void 0 : initial_target.settings,
    achieved_bundle_target: null,
    incentive_target: incentive_targets == null ? void 0 : incentive_targets[0],
    selling_plan_duration: "",
    isAdding: false,
    items_added_to_cart: false,
    show_mobile_details: false,
    max_bundle_quantity: section_settings.max_bundle_quantity,
    addToBundle,
    removeFromBundle
  });
  const getTargetTitles = /* @__PURE__ */ __name(() => {
    return bundle_targets == null ? void 0 : bundle_targets.map((item) => {
      var _a2, _b2, _c2, _d2, _e2, _f2, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
      const lowestPrice = Math.min(...bundle_products.map((product) => product.price_min));
      const highestPrice = Math.max(...bundle_products.map((product) => {
        var _a3;
        return (_a3 = product.price_max) != null ? _a3 : product.price;
      }));
      const priceVaries = ((state == null ? void 0 : state.final_price) || lowestPrice) !== ((state == null ? void 0 : state.total_price) || highestPrice);
      return ((_a2 = item.label) == null ? void 0 : _a2.trim()) ? `<span class="flex gap-2 w-full items-center">${utils.unescape(
        (_h = item.label) == null ? void 0 : _h.replace(
          "[price]",
          `<span>${utils.formatMoney(
            (state == null ? void 0 : state.final_price) || (lowestPrice - ((_c2 = (_b2 = item == null ? void 0 : item.settings) == null ? void 0 : _b2.discount_percentage) != null ? _c2 : 0) / 100 * lowestPrice - ((_e2 = (_d2 = item == null ? void 0 : item.settings) == null ? void 0 : _d2.discount_amount) != null ? _e2 : 0)) * ((section_settings == null ? void 0 : section_settings.bundle_target_type) === "item_count" ? (_f2 = item.settings) == null ? void 0 : _f2.target : 1)
          )}</span>`
        ).replace(
          "[compare_at_price]",
          `<span class="opacity-50 line-through">${utils.formatMoney(
            (state == null ? void 0 : state.total_price) || lowestPrice * ((section_settings == null ? void 0 : section_settings.bundle_target_type) === "item_count" ? (_g = item.settings) == null ? void 0 : _g.target : 1)
          )}</span>`
        )
      )}</span>` : (_z = `<span class="flex items-center gap-2">
       ${(section_settings == null ? void 0 : section_settings.bundle_target_type) === "total_price" && ((_i = item.settings) == null ? void 0 : _i.target) ? `<span>Spend ${utils.formatMoney((_j = item.settings) == null ? void 0 : _j.target)}</span>` : ""}
       ${(section_settings == null ? void 0 : section_settings.bundle_target_type) === "item_count" ? `<span>${(_k = item.settings) == null ? void 0 : _k.target} ${((_l = item.settings) == null ? void 0 : _l.target) === 1 ? "item" : "items"}</span>` : ""}
       ${((_m = item == null ? void 0 : item.settings) == null ? void 0 : _m.discount_percentage) > 0 && ((_n = select_settings == null ? void 0 : select_settings.discount_label) == null ? void 0 : _n.trim()) ? `<span class="${select_settings == null ? void 0 : select_settings.discount_label}">${(_o = item == null ? void 0 : item.settings) == null ? void 0 : _o.discount_percentage}% off</span>` : ""}
       ${((_p = item == null ? void 0 : item.settings) == null ? void 0 : _p.discount_amount) > 0 && ((_q = select_settings == null ? void 0 : select_settings.discount_label) == null ? void 0 : _q.trim()) ? `<span class="${select_settings == null ? void 0 : select_settings.discount_label}">${utils.formatMoney(
        (_r = item == null ? void 0 : item.settings) == null ? void 0 : _r.discount_percentage
      )} off</span>` : ""}
       ${(select_settings == null ? void 0 : select_settings.price_content) ? `<span class="flex-1 flex justify-end gap-2">
           ${(_y = select_settings == null ? void 0 : select_settings.price_content) == null ? void 0 : _y.replace(
        "[price]",
        `<span>${utils.formatMoney(
          (state == null ? void 0 : state.final_price) || (lowestPrice - ((_t = (_s = item == null ? void 0 : item.settings) == null ? void 0 : _s.discount_percentage) != null ? _t : 0) / 100 * lowestPrice - ((_v = (_u = item == null ? void 0 : item.settings) == null ? void 0 : _u.discount_amount) != null ? _v : 0)) * ((section_settings == null ? void 0 : section_settings.bundle_target_type) === "item_count" ? (_w = item.settings) == null ? void 0 : _w.target : 1)
        )}</span>`
      ).replace(
        "[compare_at_price]",
        priceVaries ? `<span class="opacity-50 line-through">${utils.formatMoney(
          (state == null ? void 0 : state.total_price) || lowestPrice * ((section_settings == null ? void 0 : section_settings.bundle_target_type) === "item_count" ? (_x = item.settings) == null ? void 0 : _x.target : 1)
        )}</span>` : ""
      )}` : ""}
      </span>`) == null ? void 0 : _z.replace(/\n/gi, "").trim();
    });
  }, "getTargetTitles");
  state.bundle_target_titles = getTargetTitles();
  window.Alpine.effect(() => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D, _E, _F, _G, _H, _I, _J, _K, _L;
    state.item_count = (_a2 = state.items_added) == null ? void 0 : _a2.length;
    state.total_price = state.items_added.reduce((acc, item) => {
      var _a3, _b3;
      return acc += (_b3 = item == null ? void 0 : item.price_override) != null ? _b3 : (_a3 = item.variant) == null ? void 0 : _a3.price;
    }, 0);
    state.achieved_bundle_target = (_c2 = (_b2 = [...bundle_targets].sort((a, b) => {
      var _a3, _b3;
      return ((_a3 = b.settings) == null ? void 0 : _a3.target) - ((_b3 = a == null ? void 0 : a.settings) == null ? void 0 : _b3.target);
    })) == null ? void 0 : _b2.find((bundle) => bundle.settings.target <= (state == null ? void 0 : state[bundle_type]))) == null ? void 0 : _c2.settings;
    if (select_type === "auto") {
      state.bundle_target = (_d2 = [...bundle_targets].sort((a, b) => {
        var _a3, _b3;
        return ((_a3 = a.settings) == null ? void 0 : _a3.target) - ((_b3 = a == null ? void 0 : a.settings) == null ? void 0 : _b3.target);
      }).find((bundle) => bundle.settings.target > (state == null ? void 0 : state[bundle_type]))) == null ? void 0 : _d2.settings;
    }
    let hasSellingPlan = true;
    state.selling_plan_options = (_g = (_f2 = state.item_count > 0 ? (_e2 = state.items_added) == null ? void 0 : _e2.map(({ product, variant }) => ({ ...product, variants: [variant] })) : []) == null ? void 0 : _f2.reduce((acc, product, i) => {
      var _a3;
      (_a3 = product.variants) == null ? void 0 : _a3.forEach((variant) => {
        var _a4, _b3;
        if (((_a4 = variant == null ? void 0 : variant.selling_plan_allocations) == null ? void 0 : _a4.length) === 0) {
          console.log("No selling plans for variant", variant);
          hasSellingPlan = false;
        }
        (_b3 = variant == null ? void 0 : variant.selling_plan_allocations) == null ? void 0 : _b3.forEach((allocation) => {
          acc.push(allocation);
        });
      });
      return hasSellingPlan ? acc : [];
    }, []).filter((a, i, arr) => arr.findIndex((b) => {
      var _a3, _b3;
      return ((_a3 = b == null ? void 0 : b.selling_plan) == null ? void 0 : _a3.name) === ((_b3 = a == null ? void 0 : a.selling_plan) == null ? void 0 : _b3.name);
    }) === i)) == null ? void 0 : _g.sort(
      (a, b) => sort_values.findIndex((value) => new RegExp(`${value}`, "gi").test(a.selling_plan.name)) - sort_values.findIndex((value) => new RegExp(`${value}`, "gi").test(b.selling_plan.name))
    );
    state.selling_plan_options = ((_h = state == null ? void 0 : state.selling_plan_options) == null ? void 0 : _h.every((a, i, arr) => {
      var _a3;
      if ((a == null ? void 0 : a.selling_plan_group_id) !== ((_a3 = arr[i - 1]) == null ? void 0 : _a3.selling_plan_group_id)) return [];
      return arr;
    })) ? state.selling_plan_options : [];
    console.log("items_added", state.items_added);
    console.log("selling_plan_options", state.selling_plan_options);
    if (state.selected_selling_plan) {
      state.selected_selling_plan = ((_i = state.selling_plan_options) == null ? void 0 : _i.some(
        (item) => item.selling_plan.name === state.selected_selling_plan
      )) ? state.selected_selling_plan : (_k = (_j = selling_plan_options == null ? void 0 : selling_plan_options[0]) == null ? void 0 : _j.selling_plan) == null ? void 0 : _k.name;
    }
    if (!((_l = state.selling_plan_options) == null ? void 0 : _l.length)) {
      state.selected_selling_plan = null;
    }
    const subscription_price = state.items_added.reduce((acc, item) => {
      var _a3, _b3, _c3, _d3, _e3, _f3;
      acc = acc + ((_f3 = (_d3 = item == null ? void 0 : item.price_override) != null ? _d3 : (_c3 = (_b3 = (_a3 = item.variant) == null ? void 0 : _a3.selling_plan_allocations) == null ? void 0 : _b3.find(
        (plan) => {
          var _a4, _b4, _c4, _d4, _e4;
          return ((_a4 = plan == null ? void 0 : plan.selling_plan) == null ? void 0 : _a4.name) === ((_e4 = state.selected_selling_plan) != null ? _e4 : (_d4 = (_c4 = (_b4 = state.selling_plan_options) == null ? void 0 : _b4[0]) == null ? void 0 : _c4.selling_plan) == null ? void 0 : _d4.name);
        }
      )) == null ? void 0 : _c3.price) != null ? _f3 : (_e3 = item.variant) == null ? void 0 : _e3.price);
      return acc;
    }, 0);
    state.discounted_price = state.total_price - ((_n = (_m = state.achieved_bundle_target) == null ? void 0 : _m.discount_amount) != null ? _n : 0) - state.total_price * (((_p = (_o = state == null ? void 0 : state.achieved_bundle_target) == null ? void 0 : _o.discount_percentage) != null ? _p : 0) / 100);
    state.subscription_price_before_discounts = subscription_price;
    state.subscription_price = subscription_price - ((_r = (_q = state.achieved_bundle_target) == null ? void 0 : _q.discount_amount) != null ? _r : 0) - subscription_price * (((_t = (_s = state == null ? void 0 : state.achieved_bundle_target) == null ? void 0 : _s.discount_percentage) != null ? _t : 0) / 100);
    state.before_discounts_price = state.selected_selling_plan ? state.subscription_price_before_discounts : state.total_price;
    state.final_price = state.selected_selling_plan ? state.subscription_price : state.discounted_price;
    state.target_difference = bundle_type === "item_count" ? ((_u = state.bundle_target) == null ? void 0 : _u.target) - state.item_count > 0 ? `${((_v = state.bundle_target) == null ? void 0 : _v.target) - state.item_count}` : "" : ((_w = state.bundle_target) == null ? void 0 : _w.target) - state.total_price ? `${utils.formatMoney(((_x = state.bundle_target) == null ? void 0 : _x.target) - state.item_count)}` : "";
    state.target_wording = bundle_type === "item_count" ? `${(_y = state.bundle_target) == null ? void 0 : _y.target}` : utils.formatMoney((_z = state.bundle_target) == null ? void 0 : _z.target);
    state.current_wording = bundle_type === "item_count" ? `${state.item_count}` : utils.formatMoney(state.total_price);
    state.difference_wording = bundle_type === "item_count" ? `${((_A = state.bundle_target) == null ? void 0 : _A.target) - state.item_count}` : utils.formatMoney(((_B = state.bundle_target) == null ? void 0 : _B.target) - state.total_price);
    state.selling_plan_discount_wording = ((_C = state.bundle_target) == null ? void 0 : _C.discount_amount) ? `Save ${utils.formatMoney((_D = state.bundle_target) == null ? void 0 : _D.discount_amount)}` : ((_E = state == null ? void 0 : state.bundle_target) == null ? void 0 : _E.discount_percentage) ? `${(_F = state == null ? void 0 : state.bundle_target) == null ? void 0 : _F.discount_percentage}% off` : "";
    state.target_discount_wording = ((_G = state.bundle_target) == null ? void 0 : _G.discount_amount) ? `Save ${utils.formatMoney((_H = state.bundle_target) == null ? void 0 : _H.discount_amount)}` : ((_I = state == null ? void 0 : state.bundle_target) == null ? void 0 : _I.discount_percentage) ? `${(_J = state == null ? void 0 : state.bundle_target) == null ? void 0 : _J.discount_percentage}% off` : "";
    state.discount_wording = `${utils.roundToIndex((1 - state.final_price / state.total_price) * 100, 0)}% off`;
    state.active_target_discount_wording = state.total_price > state.final_price ? state.target_discount_wording : "";
    state.active_discount_wording = state.total_price > state.final_price ? `${(_K = state == null ? void 0 : state.achieved_bundle_target) == null ? void 0 : _K.discount_percentage}% off` : "";
    state.item_added_summary = (_L = state == null ? void 0 : state.items_added) == null ? void 0 : _L.reduce((acc, item) => {
      var _a3, _b3, _c3, _d3, _e3, _f3, _g2;
      const addedIndex = acc.findIndex((item2) => {
        var _a4, _b4;
        return ((_a4 = item == null ? void 0 : item.variant) == null ? void 0 : _a4.id) === ((_b4 = item2 == null ? void 0 : item2.variant) == null ? void 0 : _b4.id);
      });
      if (addedIndex !== -1 && item.price_override === acc[addedIndex]["price_override"]) {
        acc[addedIndex]["quantity"] += 1;
      } else {
        const selling_plan = (_b3 = (_a3 = item.variant) == null ? void 0 : _a3.selling_plan_allocations) == null ? void 0 : _b3.find(
          (plan) => {
            var _a4;
            return ((_a4 = plan.selling_plan) == null ? void 0 : _a4.name) === state.selected_selling_plan;
          }
        );
        acc.push({
          quantity: 1,
          subscription: (_e3 = (_d3 = (_c3 = selling_plan == null ? void 0 : selling_plan.selling_plan) == null ? void 0 : _c3.options) == null ? void 0 : _d3.at(-1)) == null ? void 0 : _e3.value,
          price: (_g2 = selling_plan == null ? void 0 : selling_plan.price) != null ? _g2 : (_f3 = item.variant) == null ? void 0 : _f3.price,
          compare_at_price: selling_plan == null ? void 0 : selling_plan.compare_at_price,
          ...item
        });
      }
      return acc;
    }, []);
    state.bundle_target_titles = getTargetTitles();
  });
  const updateBundleById = /* @__PURE__ */ __name((bundle_id = state.bundle_target_id) => {
    var _a2, _b2, _c2, _d2;
    state.bundle_target_id = bundle_id;
    if (state.bundle_target_id || ((_a2 = state.items_added) == null ? void 0 : _a2.length)) {
      state.bundle_target = (_b2 = bundle_targets.find((target) => {
        var _a3;
        if (bundle_type === "item_count") {
          return target.id === state.bundle_target_id && target.settings.target >= ((_a3 = state.items_added) == null ? void 0 : _a3.length);
        } else {
          return target.id === state.bundle_target_id;
        }
      })) == null ? void 0 : _b2.settings;
      if (!state.bundle_target && (bundle_targets == null ? void 0 : bundle_targets.length)) {
        const bundle_target = (_d2 = [...bundle_targets].sort((a, b) => a.settings.target - b.settings.target).find((target) => {
          var _a3;
          if (bundle_type === "item_count") {
            return target.settings.target >= ((_a3 = state.items_added) == null ? void 0 : _a3.length);
          } else {
            return true;
          }
        })) != null ? _d2 : (_c2 = [...bundle_targets].sort((a, b) => b.settings.target - a.settings.target)) == null ? void 0 : _c2[0];
        state.bundle_target = bundle_target == null ? void 0 : bundle_target.settings;
        state.bundle_target_id = bundle_target == null ? void 0 : bundle_target.id;
      }
    }
  }, "updateBundleById");
  const setSellingPlan = /* @__PURE__ */ __name((name) => {
    state.selected_selling_plan = name;
  }, "setSellingPlan");
  const handleAddToCart = /* @__PURE__ */ __name(async (action) => {
    var _a2, _b2, _c2, _d2;
    try {
      state.isAdding = true;
      const data = await _cart.add({
        items: (_a2 = state.items_added) == null ? void 0 : _a2.map((item) => {
          var _a3, _b3, _c3, _d3, _e2, _f2;
          return {
            id: (_a3 = item == null ? void 0 : item.variant) == null ? void 0 : _a3.id,
            properties: {
              _bundle_id: random_id,
              Bundle: (_b3 = state.achieved_bundle_target) == null ? void 0 : _b3.label
            },
            quantity: 1,
            selling_plan: (_f2 = (_e2 = (_d3 = (_c3 = item.variant) == null ? void 0 : _c3.selling_plan_allocations) == null ? void 0 : _d3.find(
              (plan) => {
                var _a4;
                return ((_a4 = plan == null ? void 0 : plan.selling_plan) == null ? void 0 : _a4.name) === state.selected_selling_plan;
              }
            )) == null ? void 0 : _e2.selling_plan) == null ? void 0 : _f2.id
          };
        })
      });
      if (data.cart_error) {
        state.isAdding = false;
        return;
      }
      if (action === "add_to_cart") {
        _stores.modal.setId("modal--cart-drawer");
      }
      if (action === "checkout") {
        (_b2 = document.querySelector('[data-cart-drawer-checkout-form] button[name="checkout"]')) == null ? void 0 : _b2.click();
        state.isAdding = false;
        state.items_added_to_cart = true;
        await utils.delay(3500);
        state.items_added_to_cart = false;
        return;
      }
      state.items_added = [];
      state.bundle_target_id = (_c2 = bundle_targets == null ? void 0 : bundle_targets[0]) == null ? void 0 : _c2.id;
      state.total_price = 0;
      state.discounted_price = 0;
      state.final_price = 0;
      state.subscription_price = 0;
      state.selling_plan_discount_wording = "";
      state.discount_wording = "";
      state.item_count = 0;
      state.target_difference = "";
      state.selling_plan_options = selling_plan_options;
      state.selected_selling_plan = null;
      state.bundle_target = (_d2 = bundle_targets == null ? void 0 : bundle_targets[0]) == null ? void 0 : _d2.settings;
      state.achieved_bundle_target = null;
      state.incentive_target = incentive_targets == null ? void 0 : incentive_targets[0];
      state.selling_plan_duration = "";
      state.isAdding = false;
      state.show_mobile_details = false;
      state.max_bundle_quantity = section_settings.max_bundle_quantity;
      state.items_added_to_cart = true;
      await utils.delay(3500);
      state.items_added_to_cart = false;
    } catch (error) {
      console.log(error);
    }
  }, "handleAddToCart");
  const getDynamicText = /* @__PURE__ */ __name((content) => {
    return utils.getBracketInputDynamicText(content, state);
  }, "getDynamicText");
  const getDynamicValue = /* @__PURE__ */ __name((content) => {
    return utils.getBracketInputDynamicValue(content, state);
  }, "getDynamicValue");
  const getDynamicValueWithFallbacks = /* @__PURE__ */ __name((content) => {
    var _a2;
    return (_a2 = content.split(",")) == null ? void 0 : _a2.reduce((acc, item) => {
      acc || (acc = utils.getBracketInputDynamicValue(item.trim(), state));
      return acc;
    }, "");
  }, "getDynamicValueWithFallbacks");
  const showConditionally = /* @__PURE__ */ __name((show_conditionally) => {
    if (!show_conditionally) {
      return true;
    }
    switch (show_conditionally) {
      case "opened":
        return state.show_mobile_details;
      case "closed":
        return !state.show_mobile_details;
      case "always": {
        return true;
      }
      case "active_discount": {
        return !!state.achieved_bundle_target;
      }
      case "no_active_discount": {
        return !state.achieved_bundle_target;
      }
      case "target_reached": {
        return !state.target_difference;
      }
      case "target_not_reached": {
        return !!state.target_difference;
      }
    }
  }, "showConditionally");
  const showBasedOnBundleState = /* @__PURE__ */ __name((show_based_on_bundle_state) => {
    var _a2, _b2;
    if (!show_based_on_bundle_state) {
      return true;
    }
    switch (show_based_on_bundle_state) {
      case "always":
        return true;
      case "bundle_empty":
        return state[bundle_type] === 0;
      case "some_items_added":
        return state[bundle_type] > 0;
      case "items_added":
        return state[bundle_type] > 0 && state[bundle_type] < ((_a2 = state == null ? void 0 : state.bundle_target) == null ? void 0 : _a2.target);
      case "bundle_complete":
        return state[bundle_type] >= ((_b2 = state == null ? void 0 : state.bundle_target) == null ? void 0 : _b2.target);
    }
  }, "showBasedOnBundleState");
  return {
    bundle: state,
    bundle_targets,
    bundle_target_objects,
    incentive_targets,
    section_settings,
    bundle_type,
    selling_plan_options,
    addToBundle,
    removeFromBundle,
    setSellingPlan,
    updateBundleById,
    handleAddToCart,
    getDynamicValue,
    getDynamicValueWithFallbacks,
    getDynamicText,
    showConditionally,
    showBasedOnBundleState
  };
}, "initBundle");
window._sections["initBundle"] = initBundle;
